import { render } from "./policyDetails.vue?vue&type=template&id=ab096ecc&scoped=true&lang=true"
import script from "./policyDetails.vue?vue&type=script&lang=js"
export * from "./policyDetails.vue?vue&type=script&lang=js"

import "./policyDetails.vue?vue&type=style&index=0&id=ab096ecc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab096ecc"]])

export default __exports__